import { capitalize } from '@aibees/shared/utils';
import { Nullable } from 'vitest';
import { SearchFilterTreeOptions } from '../types';

export enum CompanyFundingType {
  PRE_SEED = 'PRE_SEED',
  SEED = 'SEED',
  SERIES_A = 'SERIES_A',
  SERIES_B = 'SERIES_B',
  SERIES_C = 'SERIES_C',
  SERIES_D = 'SERIES_D',
  SERIES_E = 'SERIES_E',
  SERIES_F = 'SERIES_F',
  SERIES_G = 'SERIES_G',
  SERIES_H = 'SERIES_H',
  SERIES_I = 'SERIES_I',
  SERIES_J = 'SERIES_J',
  VENTURE_ROUND = 'VENTURE_ROUND',
  ANGEL = 'ANGEL',
  PRIVATE_EQUITY = 'PRIVATE_EQUITY',
  DEBT_FINANCING = 'DEBT_FINANCING',
  CONVERTIBLE_NOTE = 'CONVERTIBLE_NOTE',
  GRANT = 'GRANT',
  CORPORATE_ROUND = 'CORPORATE_ROUND',
  EQUITY_CROWDFUNDING = 'EQUITY_CROWDFUNDING',
  PRODUCT_CROWDFUNDING = 'PRODUCT_CROWDFUNDING',
  SECONDARY_MARKET = 'SECONDARY_MARKET',
  POST_IPO_EQUITY = 'POST_IPO_EQUITY',
  POST_IPO_DEBT = 'POST_IPO_DEBT',
  POST_IPO_SECONDARY = 'POST_IPO_SECONDARY',
  NON_EQUITY_ASSISTANCE = 'NON_EQUITY_ASSISTANCE',
  INITIAL_COIN_OFFERING = 'INITIAL_COIN_OFFERING',
  UNDISCLOSED = 'UNDISCLOSED',
  SERIES_UNKNOWN = 'SERIES_UNKNOWN',
  FUNDING_ROUND = 'FUNDING_ROUND',
}

export const fundingTypeCategories = {
  ALTERNATIVE_FINANCING: {
    label: 'Alternative Funding',
    children: [
      CompanyFundingType.ANGEL,
      CompanyFundingType.GRANT,
      CompanyFundingType.EQUITY_CROWDFUNDING,
      CompanyFundingType.PRODUCT_CROWDFUNDING,
      CompanyFundingType.INITIAL_COIN_OFFERING,
      CompanyFundingType.NON_EQUITY_ASSISTANCE,
      CompanyFundingType.CONVERTIBLE_NOTE,
      CompanyFundingType.UNDISCLOSED,
    ],
  },
  DEBT_FINANCING: {
    label: 'Debt & Loan-Based Financing',
    children: [
      CompanyFundingType.DEBT_FINANCING,
      CompanyFundingType.POST_IPO_DEBT,
    ],
  },
  EQUITY_FINANCING: {
    label: 'Equity Rounds',
    children: [
      CompanyFundingType.PRE_SEED,
      CompanyFundingType.SEED,
      CompanyFundingType.SERIES_A,
      CompanyFundingType.SERIES_B,
      CompanyFundingType.SERIES_C,
      CompanyFundingType.SERIES_D,
      CompanyFundingType.SERIES_E,
      CompanyFundingType.SERIES_F,
      CompanyFundingType.SERIES_G,
      CompanyFundingType.SERIES_H,
      CompanyFundingType.SERIES_I,
      CompanyFundingType.SERIES_J,
      CompanyFundingType.VENTURE_ROUND,
      CompanyFundingType.CORPORATE_ROUND,
      CompanyFundingType.PRIVATE_EQUITY,
    ],
  },
  SECONDARY_MARKET: {
    label: 'Secondary & Miscellaneous',
    children: [
      CompanyFundingType.POST_IPO_EQUITY,
      CompanyFundingType.POST_IPO_SECONDARY,
      CompanyFundingType.SECONDARY_MARKET,
      CompanyFundingType.FUNDING_ROUND,
    ],
  },
};

const getFundingTypeOptions = () =>
  Object.values(fundingTypeCategories).map((cat) => ({
    id: cat.label,
    value: cat.label,
    label: cat.label,
    doNotSetValueOnSelection: true,
    subtitle: `${cat.children.length} Types`,
    children: cat.children.map((fundingType) => ({
      id: cat.label + fundingType,
      value: fundingType,
      parentId: cat.label,
      parentValue: cat.label,
      label: humanReadableFundingType(fundingType as CompanyFundingType),
    })),
  })) as SearchFilterTreeOptions[];

export const FUNDING_TYPE_FILTER_OPTIONS = [getFundingTypeOptions()];

export function humanReadableFundingType(type: Nullable<CompanyFundingType>) {
  if (!type) return '';
  switch (type) {
    case CompanyFundingType.PRE_SEED:
      return 'Pre-Seed';
    case CompanyFundingType.POST_IPO_DEBT:
    case CompanyFundingType.POST_IPO_EQUITY:
    case CompanyFundingType.POST_IPO_SECONDARY:
      return capitalize(type.replaceAll('_', ' ')).replaceAll(
        'Post Ipo',
        'Post-IPO'
      );
    case CompanyFundingType.NON_EQUITY_ASSISTANCE:
      return 'Non-Equity Assistance';
    default:
      return capitalize(type.replaceAll('_', ' '));
  }
}
